import selectedAtteributes from "@/constants/selectedAttrubites";
import axiosRequest from "@/utils/axios-config";

/*
===============================|> All Category APis <|===============================
01 |--> get category tree
02 |--> get products by category id
===============================|> All Category APis <|===============================
*/

// 01- =============> get category tree
const getCategoryTree = async (handshake) => {
  const config = {
    method: "GET",
    url: "/mstore/category/tree",
    headers: {
      Authorization: `Bearer ${handshake}`,
      "Content-Type": "application/json",
    },
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getTopCategoryAndBrand = async (handshake, categoryId) => {
  const config = {
    method: "GET",
    url: `/customer/topCategoryAndBrand?categoryId=${categoryId}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
      "Content-Type": "application/json",
    },
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};
// 02- =============> get products by category id
// * sortBy can be position | price
// * sortDir can be ASC | DESC
const getProductsByCategoryId = async (
  handshake,
  categoryId,
  pageSize = 30,
  pageNo = 0,
  filterKeys = "",
  sortKeys = "sortBy=price&sortDir=DESC"
) => {
  console.log('fiter jeys --->>', filterKeys)
  const config = {
    method: "get",
    url: `/search/products/facets/category/${categoryId}?pageNo=${pageNo}&pageSize=${pageSize}&${selectedAtteributes}&${filterKeys}&${sortKeys}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };
  // if(!getFullResponse){
  //   config.url += `&${selectedAtteributes}`
  // }
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getFilterableAttributesCategory = async (handshake, categoryId) => {
  const config = {
    method: "get",
    url: `/filterable-attributes/category/${categoryId}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getProductsByCategory = async (
  handshake,
  categoryId,
  pageSize = 30,
  pageNo = 0,
  getFullResponse = true
) => {
  const config = {
    method: "get",
    url: `/search/products/category/${categoryId}?pageSize=${pageSize}&pageNo=${pageNo}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };
  if (!getFullResponse) {
    config.url += `&${selectedAtteributes}`;
  }
  try {
    const req = await axiosRequest(config);
    console.log("===========>>", categoryId, req?.data?.data?.products?.length);
    return req;
  } catch (error) {
    console.log("===========>>", categoryId, error.error);
    return error;
  }
};

const getFilterableAttributes = async (handshake, categoryId) => {
  const config = {
    method: "get",
    url: `filterable-attributes/category/${categoryId}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getRatedProductsByCategory = async (
  handshake,
  categoryId,
  pageSize = 30,
  pageNo = 0,
  getFullResponse = true
) => {
  await getProductsByCategory(
    handshake,
    categoryId,
    pageSize,
    pageNo,
    getFullResponse
  );
};

const getCategoryJsonById = async (handshake, categoryId) => {
  const config = {
    method: "get",
    url: `/json/categoryJsonById/${categoryId}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  getRatedProductsByCategory,
  getCategoryTree,
  getTopCategoryAndBrand,
  getProductsByCategoryId,
  getFilterableAttributesCategory,
  getProductsByCategory,
  getFilterableAttributes,
  getCategoryJsonById,
};
